import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Public.css';
import logo from './logo.png';
export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <nav className="pub-navbar">
      <div className="pub-container pub-nav-inner">
        <Link to="/" className="pub-logo" onClick={() => setOpen(false)}>
          <img src={logo} alt="EventHub Logo" className="pub-logo-mark" />
          <span className="pub-logo-text">AI<span> World Community</span></span>
          {/* <span className="pub-logo-mark">E</span>
          <span className="pub-logo-text">Event<span>Hub</span></span> */}
        </Link>
        <button className="pub-nav-toggle" onClick={() => setOpen(o => !o)} aria-label="Menu">
          <span /><span /><span />
        </button>
        <div className={`pub-nav-links ${open ? 'open' : ''}`}>
          <Link to="/" className={pathname === '/' ? 'active' : ''} onClick={() => setOpen(false)}>Events</Link>
          <a href="/#features" onClick={() => setOpen(false)}>Why EventHub</a>
          <a href="/#contact" onClick={() => setOpen(false)}>Contact</a>
          <Link to="/admin/login" className="pub-nav-cta" onClick={() => setOpen(false)}>Admin</Link>
        </div>
      </div>
    </nav>
  );
}
